






import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';

@Component({ name: 'SimulatedField' })
export default class extends SaascadaVue {

    @Prop({required: true})
    hasSimulatedValue: boolean;

    get simulationModeEnabled() {
        return LendingAccountModule.simulationModeEnabled;
    }

}
